import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DeleteSocialNetwork } from 'src/app/utils/interfaces';
import { Empresa, Puesto, Usuario } from 'src/app/utils/models';
import { environment } from 'src/environments/environment';
import { DataUser } from '../../../utils/models/data-user';

@Injectable({
  providedIn: 'root',
})

export class DashboardTarjetaService {

  headers = new HttpHeaders().set('Content-Type', 'application/json')
  dataUser: DataUser;

  constructor(private readonly http: HttpClient) {
    this.dataUser = new DataUser();
  }

  // setLocalStorageData(data: any) {
  //   data = {
  //     nombre: 'daniel',
  //     apellido: 'Magadan',
  //   };
  //   localStorage.setItem('data-preview', JSON.stringify(data));
  // }

  // getLocalStorageData(data: any) {
  //   data = localStorage.getItem('data-preview');
  //   console.log(data);
  // }

  getPuestos(): Observable<Puesto[]> {
    return this.http.get<Puesto[]>(environment.dashboard + `usuarios/puestos`);
  }

  getInfo(params: HttpParams): Observable<any> {
    return this.http.get(environment.dashboard + `dashboard/get-info/`, {
      params,
    });
  }

  getInfoV2(idEmpresa:number, diaInicio: number, mesInicio: number, anioInicio: number, diaFinal: number, mesFinal: number, anioFinal: number): Observable<any> {

    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${this.dataUser.token}`,
    });

    let params = new HttpParams();
    params = params.append('idEmpresa', idEmpresa.toString());
    params = params.append('diaInicio', diaInicio.toString());
    params = params.append('mesInicio', mesInicio.toString());
    params = params.append('anioInicio', anioInicio.toString());
    params = params.append('diaFinal', diaFinal.toString());
    params = params.append('mesFinal', mesFinal.toString());
    params = params.append('anioFinal', anioFinal.toString());

    const API_ENDPOINT: any = environment.apis_goadmin.concat('api/v1/dashboard/get-info');
    return this.http.get(API_ENDPOINT, {  params: params });
  }


  getUsers(params: HttpParams): Observable<any> {
    return this.http.get(environment.dashboard + `usuarios/`, { params });
  }

  getUsersV2(idEmpresa: number): Observable<any> {

    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${this.dataUser.token}`,
    });

    let params = new HttpParams();
    params = params.append('idEmpresa', idEmpresa.toString());

    const API_ENDPOINT: any = environment.apis_goadmin.concat('api/v1/usuarios');
    return this.http.get(API_ENDPOINT, {  params: params });
  }

  deleteUsersV2(idUsuario: number): Observable<any> {

    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${this.dataUser.token}`,
    });

    let params = new HttpParams();
    params = params.append('idUsuario', idUsuario.toString());

    const API_ENDPOINT: any = environment.apis_goadmin.concat('api/v1/usuarios');
    return this.http.delete(API_ENDPOINT, {  params: params });
  }

  getUserById(idUsuario: number): Observable<any> {
    return this.http.get(environment.dashboard + `usuarios/${idUsuario}`);
  }

  getUserByIdV2(idUsuario: number): Observable<any> {

    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${this.dataUser.token}`,
    });

    let params = new HttpParams();
    params = params.append('idUsuario', idUsuario.toString());

    const API_ENDPOINT: any = environment.apis_goadmin.concat('api/v1/usuarios/tarjeta');
    return this.http.get(API_ENDPOINT, {  params: params });
  }

  getUserByIdDashboard(idUsuario: number): Observable<Usuario> {
    return this.http.get<Usuario>(
      environment.dashboard + `usuarios/editar/${idUsuario}`
    );
  }

  getUserByIdDashboardV2(idUsuario: number): Observable<any> {

    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${this.dataUser.token}`,
    });

    let params = new HttpParams();
    params = params.append('idUsuario', idUsuario.toString());

    const API_ENDPOINT: any = environment.apis_goadmin.concat('api/v1/usuarios/detalles');
    return this.http.get(API_ENDPOINT, {  params: params });
  }

  updateUserInfo(idUsuario: number, body: any): Promise<any> {
    return this.http
      .patch(environment.dashboard + `usuarios/${idUsuario}`, body)
      .toPromise();
  }

  getUserTarjetaPortadaInfo(idTarjeta: number): Observable<any> {
    return this.http.get(environment.dashboard + `usuarios/${idTarjeta}`);
  }

  getServices(idEmpresa: number): Observable<any> {
    return this.http.get(
      environment.dashboard + `servicios?empresa=${idEmpresa}`
    );
  }

  getServicesV2(idEmpresa: number): Observable<any> {

    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${this.dataUser.token}`,
    });

    let params = new HttpParams();
    params = params.append('idEmpresa', idEmpresa.toString());

    const API_ENDPOINT: any = environment.apis_goadmin.concat('api/v1/servicios');
    return this.http.get(API_ENDPOINT, {  params: params });
  }

  setService(body: any): Observable<any> {
    const formData = new FormData();
    Object.keys(body).forEach((key) => formData.append(key, body[key]));
    return this.http.post(environment.dashboard + `servicios`, formData);
  }

  setServiceV2(body: any): Observable<any> {
    const formData = new FormData();
    Object.keys(body).forEach((key) => formData.append(key, body[key]));

    const API_ENDPOINT: any = environment.apis_goadmin.concat('api/v1/servicios');
    return this.http.post(API_ENDPOINT, formData);
  }

  updateService(body: any): Observable<any> {
    const idServicioEmpresa = body.idServicioEmpresa;
    const formData = new FormData();
    Object.keys(body).forEach((key) => formData.append(key, body[key]));
    return this.http.patch(
      environment.dashboard + `servicios/${idServicioEmpresa}`,
      formData
    );
  }

  updateServiceV2(body: any): Observable<any> {
    const formData = new FormData();
    Object.keys(body).forEach((key) => formData.append(key, body[key]));

    const API_ENDPOINT: any = environment.apis_goadmin.concat('api/v1/servicios');
    return this.http.post(API_ENDPOINT, formData);
  }

  updateServicePosicion(idServicioEmpresa: number, body: any): Observable<any> {
    return this.http.patch(
      environment.dashboard + `servicios/posicion/${idServicioEmpresa}`,
      body
    );
  }

  updateServicePosicionV2(servicios: string, idEmpresa: number): Observable<any> {

    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${this.dataUser.token}`,
    });

    let params = new HttpParams();
    params = params.append('servicios', servicios);
    params = params.append('idEmpresa', idEmpresa.toString());

    const API_ENDPOINT: any = environment.apis_goadmin.concat('api/v1/servicios/posicion');
    return this.http.get(API_ENDPOINT, {  params: params });
  }

  deleteService(idServicioEmpresa: number): Observable<any> {
    return this.http.delete(
      environment.dashboard + `servicios/${idServicioEmpresa}`
    );
  }

  deleteServiceV2(idServicioEmpresa: number, idEmpresa: number): Observable<any> {

    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${this.dataUser.token}`,
    });

    let params = new HttpParams();
    params = params.append('idServicioEmpresa', idServicioEmpresa.toString());
    params = params.append('idEmpresa', idEmpresa.toString());

    const API_ENDPOINT: any = environment.apis_goadmin.concat('api/v1/servicios');
    return this.http.delete(API_ENDPOINT, {  params: params });
  }

  getGaleria(idEmpresa: number): Observable<any> {
    return this.http.get(
      environment.dashboard + `galeria?empresa=${idEmpresa}`
    );
  }

  getGaleriaV2(idEmpresa: number): Observable<any> {

    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${this.dataUser.token}`,
    });

    let params = new HttpParams();
    params = params.append('idEmpresa', idEmpresa.toString());

    const API_ENDPOINT: any = environment.apis_goadmin.concat('api/v1/galeria');
    return this.http.get(API_ENDPOINT, {  params: params });
  }

  uploadExcelFile(body: any): Observable<any> {
    const formData = new FormData();
    Object.keys(body).forEach((key) => formData.append(key, body[key]));
    return this.http.post(environment.dashboard + `usuarios/excel`, formData);
  }

  setGaleria(body: any): Observable<any> {
    const formData = new FormData();
    Object.keys(body).forEach((key) => formData.append(key, body[key]));
    return this.http.post(environment.dashboard + `galeria`, formData);
  }

  setGaleriaV2(body: any): Observable<any> {
    const formData = new FormData();
    Object.keys(body).forEach((key) => formData.append(key, body[key]));

    const API_ENDPOINT: any = environment.apis_goadmin.concat('api/v1/galeria');
    return this.http.post(API_ENDPOINT, formData);
  }

  deleteGaleria(idFile: number): Observable<any> {
    return this.http.delete(environment.dashboard + `galeria/${idFile}`);
  }

  deleteGaleriaV2(idArchivo: number): Observable<any> {

    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${this.dataUser.token}`,
    });

    let params = new HttpParams();
    params = params.append('idArchivo', idArchivo.toString());

    const API_ENDPOINT: any = environment.apis_goadmin.concat('api/v1/galeria');
    return this.http.delete(API_ENDPOINT, {  params: params });
  }

  setConfig(body: any, flag: boolean): Observable<any> {
    const formData = new FormData();
    Object.keys(body).forEach((key) => formData.append(key, body[key]));
    if (flag) {
      return this.http.post(environment.dashboard + `configuracion`, formData);
    }
    return this.http.patch(
      environment.dashboard + `configuracion/${body.idConfiguracion}`,
      formData
    );
  }

  setConfigV2(body: any, flag: boolean): Observable<any> {
    const formData = new FormData();
    Object.keys(body).forEach((key) => formData.append(key, body[key]));

    if (flag) {
      return this.http.post(environment.apis_goadmin + `api/v1/configuracion`, formData);
    }

    const API_ENDPOINT: any = environment.apis_goadmin.concat('api/v1/configuracion');
    return this.http.post(API_ENDPOINT, formData);
  }

  getConfig(idEmpresa: number): Observable<any> {
    return this.http.get(
      environment.dashboard + `configuracion?empresa=${idEmpresa}`
    );
  }
  

  getConfigV2(idEmpresa: number): Observable<any> {

    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      // 'Authorization': `Bearer ${this.dataUser.token}`,
    });

    let params = new HttpParams();
    params = params.append('idEmpresa', idEmpresa.toString());

    const API_ENDPOINT: any = environment.apis_goadmin.concat('api/v1/configuracion');
    return this.http.get(API_ENDPOINT, {  params: params });
  }

  // Redes sociales

  setRedSocial(body: any): Observable<any> {
    return this.http.post(environment.dashboard + `usuarios/redes`, body);
  }

  // Empresas
  getEmpresaById(idEmpresa: number): Observable<any> {
    return this.http.get(environment.dashboard + `empresas/${idEmpresa}`);
  }

  setEmpresa(empresa: Empresa) {
    return this.http.post(environment.dashboard + `empresas`, empresa);
  }

  updateEmpresa(empresa: Empresa) {
    const { idEmpresa } = empresa;
    return this.http.patch(
      environment.dashboard + `empresas/${idEmpresa}`,
      empresa
    );
  }
  deleteEmpresa(idEmpresa: number) {
    return this.http.delete(environment.dashboard + `empresas/${idEmpresa}`);
  }

  getEmpresas(): Promise<any> {
    return this.http.get<any>(environment.dashboard + `empresas`).toPromise();
  }

  // Actualiza el perfil del usuario
  updateProfile(body: any): Promise<any> {
    body.idioma = 'esp';
    const formData = new FormData();
    Object.keys(body).forEach((key) => formData.append(key, body[key]));
    return this.http
      .post<any>(
        environment.api_apisqa.concat('api/Profile/profileGuardar'),
        formData
      )
      .toPromise();
  }

  // Registrar Usuario Primera vez, retorna idUsuario
  crearUser(body: any): Promise<any> {
    const formData = new FormData();
    Object.keys(body).forEach((key) => formData.append(key, body[key]));
    return this.http
      .post<any>(
        environment.api_apisqa.concat('api/Home/continuarV3'),
        formData
      )
      .toPromise();
  }

  // Crea o Edita tarjeta Primera vez Retorna idTarjeta
  crearTarjetaPortada(body: any): Promise<any> {
    const formData = new FormData();
    Object.keys(body).forEach((key) => formData.append(key, body[key]));
    return this.http
      .post<any>(
        environment.api_qaapis.concat('api/PanelPortada/tarjetaPortadaGuardar'),
        formData
      )
      .toPromise();
  }

  // Crea o edita Tarjeta detellla
  createDetalles(body: any): Promise<any> {
    const formData = new FormData();
    Object.keys(body).forEach((key) => formData.append(key, body[key]));
    return this.http
      .post<any>(
        environment.api_qaapis.concat('api/PanelSobreMi/guardarInfoSobreMi'),
        formData
      )
      .toPromise();
  }

  eliminarRedSocial(body: DeleteSocialNetwork): Promise<any> {
    return this.http
      .post(
        environment.api_apisqa.concat('api/PanelSobreMi/redesSocialesEliminar'),
        body
      )
      .toPromise();
  }

  addRedSocial(body: any): Observable<any> {
    return this.http.post(
      environment.api_apisqa.concat('api/PanelSobreMi/redesSocialesGuardar'),
      body
    );
  }
}
